import React, { useEffect } from "react";
import SkipTooltipBgNx from "../../../assets/svgs/SkipTooltipBgNx"
import SkipTooltipTimerIcon from "../../../assets/svgs/SkipTooltipTimerIcon"
import styles from "./styles.module.css";
import { getWidth } from "../../../utils/relativeSizes";
import clsx from "clsx";
import { formatTime } from "../utils";
import { useSelector } from "react-redux";
import { getIsSkipTooltipVisible, getTimeBankTimeLeft } from "../../../store/selectors/ludoboardSelectors";
import { setIsSkipTooltipVisible } from "../../../store/actions/ludoboardActions";

const SIX_SECONDS = 6000;

function SkipTooltip() {
  const isSkipTooltipVisible = useSelector(getIsSkipTooltipVisible)
  const timeBankTimeLeft = useSelector(getTimeBankTimeLeft)
  useEffect(() => {
    let myTimeout: NodeJS.Timeout;
    if (isSkipTooltipVisible) {
      myTimeout = setTimeout(() => {
        setIsSkipTooltipVisible(false)
      }, SIX_SECONDS)
    }
    return () => {
      if (myTimeout) {
        clearTimeout(myTimeout)
      }
    }
  }, [isSkipTooltipVisible])

  if (!isSkipTooltipVisible) {
    return null
  }

  return (
    <div className={clsx(styles.tooltipContent, "absolute")}>
      <div 
        className={clsx(styles.contentWrapper, "absolute flex alignItemCenter")}
        style={{gap: getWidth(8)}}
      >
        <span className={clsx(styles.extraTimeText, "fontWeightBold fontSizeXs fontColorWhite")}>Extra time Left</span>
        <div className={clsx(styles.timeWrapper)}>
          <SkipTooltipTimerIcon height={getWidth(16)} width={getWidth(16)} />
          <span className={clsx(styles.timeText, "fontWeightBold fontSizeSm12")}>
            {formatTime(timeBankTimeLeft || 0)}
            {/* {formatTime(5)} */}
          </span>
        </div>
      </div>
    </div>
  );
}

export default SkipTooltip;